import View from './View';
import icon from '@plone/volto/icons/collection.svg';

const ContactFormBlock = {
  id: 'contact_form',
  title: 'Contact Form',
  icon: icon,
  group: 'homepage',
  view: View,
  restricted: false,
  mostUsed: false,
};

export default ContactFormBlock;